module.exports = __webpack_public_path__ + "img/org_symbol.9296ace0.png";